<!-- 查询控件 -->
<template>
    <div class="config-box">
        <el-form-item label="交互按钮" label-width="80">
            <FontSet renderType="color" v-model="buttonColor"></FontSet>
        </el-form-item>
        <el-form-item label="按钮圆角" label-width="80">
            <FontSet renderType="size" v-model="buttonRadius"></FontSet>
        </el-form-item>
        <!-- <el-form-item label="条件间距" label-width="80">
            <FontSet renderType="size" v-model="conditionGap"></FontSet>
        </el-form-item> -->
        <el-form-item label="条件名称" label-width="80">
            <FontSet renderType="color, size" v-model="conditionName"></FontSet>
        </el-form-item>
        <el-form-item label="背景色" label-width="80">
            <FontSet renderType="color" v-model="background"></FontSet>
        </el-form-item>
        <el-form-item label="边框" label-width="80">
            <FontSet renderType="color, size" v-model="border"></FontSet>
        </el-form-item>
        <el-form-item label="圆角" label-width="80">
            <FontSet renderType="size" v-model="borderRadius"></FontSet>
        </el-form-item>
        <el-form-item label="文本" label-width="80">
            <FontSet renderType="color, size" v-model="textSet"></FontSet>
        </el-form-item>
    </div>
</template>
  
<script>
import FontSet from './fontSet.vue'

export default {
    name: "searchConfig",
    data() {
        return {
            buttonColor: this.modelValue?.buttonColor,
            buttonRadius: this.modelValue?.buttonRadius,
            conditionGap: this.modelValue?.conditionGap,
            conditionName: this.modelValue?.conditionName,
            background: this.modelValue?.background,
            border: this.modelValue?.border,
            borderRadius: this.modelValue?.borderRadius,
            textSet: this.modelValue?.textSet,
        }
    },
    props: {
        modelValue: {
            type: Object,
            default: () => {
                return {
                    buttonColor: {},
                    buttonRadius: {},
                    conditionGap: {},
                    conditionName: {},
                    background: {},
                    border: {},
                    borderRadius: {},
                    textSet: {},
                }
            }
        },
    },
    watch: {
        buttonColor: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    buttonColor: val,
                })
            },
        },
        buttonRadius: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    buttonRadius: val,
                })
            },
        },
        conditionGap: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    conditionGap: val,
                })
            },
        },
        conditionName: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    conditionName: val,
                })
            },
        },
        background: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    background: val,
                })
            },
        },
        border: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    border: val,
                })
            },
        },
        borderRadius: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    borderRadius: val,
                })
            },
        },
        textSet: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    textSet: val,
                })
            },
        },
    },
    components: {
        FontSet,
    },
    mounted() {
    },
    methods: {
    }
};
</script>
  
<style lang="scss" scoped>
.config-box {
    padding: 5px 0;
}
</style>